import React from 'react';
import { common } from '../../common/constants/configConstants';

const { keyBoardEventCode } = common;

type ScrollerBarProps = {
  scrollClassNames: string;
  scrollIconClassName: string;
  scroll: () => void;
  isDisabled: boolean;
};

const ScrollerBar = ({
  scrollClassNames,
  scrollIconClassName,
  scroll,
  isDisabled
}: ScrollerBarProps): JSX.Element => {
  return (
    <div
      data-testid='game-carousel-scroll-bar'
      className={scrollClassNames}
      onClick={scroll}
      aria-disabled={isDisabled}
      onKeyDown={e => {
        if (e.code === keyBoardEventCode.enter) {
          e.stopPropagation();
          e.preventDefault();
          scroll();
        }
      }}
      role='button'
      tabIndex={0}>
      <div className='arrow'>
        <span className={scrollIconClassName} />
      </div>
      <div className='spacer' />
    </div>
  );
};

export default ScrollerBar;
